import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Suspense } from 'react';

import VStack from '@/components/Layout/VStack';

import { DataPipelineDetailHeader } from './-layout/DataPipelineDetailHeader';

export const Route = createFileRoute(
  '/_staff/settings/data-connector/inbound/data-pipeline/$id/_pipeline-detail',
)({
  component: Layout,
});

function Layout() {
  return (
    <VStack>
      <Suspense>
        <DataPipelineDetailHeader />
      </Suspense>
      <Outlet />
    </VStack>
  );
}
